export default "__VITE_ASSET__DvjDvnel__"